import React from 'react';
import {
  Box,
  HeadingText,
  ParagraphText,
  Button,
} from '@leagueplatform/genesis-core';
import { LinkLegacy as Link } from '@leagueplatform/routing';
import { useStaticAsset } from '@leagueplatform/asset-config';
import { EVENT_NAME, trackAnalyticsEvent } from '@leagueplatform/analytics';
import * as CONSTANTS from '../utils/constant';
import { DOCUMENT_CENTER_ASSET_KEYS } from '../types/document-center.types';

export function NoDocsComponent(props: any) {
  const { isAllDocs, letterType } = props;
  const noDocsIcon = useStaticAsset(DOCUMENT_CENTER_ASSET_KEYS.NO_DOCS);

  return (
    <Box
      className="noDocs-Container"
      css={{
        margin: '0 auto',
        maxWidth: '450px',
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'center',
        justifyContent: 'center',
        padding: '0 24px',
        '& img': {
          margin: 'auto',
        },
        '@desktop': {
          margin: '40px auto 0',
          padding: 0,
        },
        '@laptop': {
          margin: '40px auto 0',
          padding: 0,
        },
      }}
    >
      <img src={noDocsIcon as string} width="176px" alt="icon" />
      <HeadingText
        size="sm"
        level="5"
        css={{
          fontSize: '20px',
          lineHeight: '28px',
          fontFamily: `${CONSTANTS.FONT_POPPINS}`,
          letterSpacing: '0.25px',
          color: '#2C3135',
          margin: '24px auto 8px',
          fontWeight: 600,
        }}
      >
        {isAllDocs
          ? CONSTANTS.NO_DOCUMENTS_AVAILABLE
          : CONSTANTS.NO_RECENT_DOCUMENTS}
      </HeadingText>
      <ParagraphText
        css={{
          color: '#2C3135',
          fontFamily: `${CONSTANTS.FONT_ROBOTO}`,
          lineHeight: '24px',
          fontWeight: 400,
          fontSize: '16px',
        }}
      >
        {isAllDocs
          ? CONSTANTS.NO_DOCS_CONTENT
          : CONSTANTS.NO_RECENT_DOCS_CONTENT}
      </ParagraphText>
      <Button
        priority="primary"
        size="large"
        textAlign="start"
        type="button"
        data-testid="chatNow"
        css={{
          textAlign: 'center',
          width: '256px',
          margin: '16px auto',
          fontFamily: `${CONSTANTS.FONT_POPPINS}`,
          justifyContent: 'space-around',
          '@mobile': {
            width: 'auto',
          },
        }}
        onClick={() => {
          trackAnalyticsEvent(EVENT_NAME.BUTTON_CLICKED, {
            detail: CONSTANTS.CHAT_NOW,
            product_area: CONSTANTS.DOCUMENT_CENTER,
            sub_product_area: letterType,
            screen_name: letterType,
            path: window.location.pathname,
            event_author: CONSTANTS.ENGEN,
          });
        }}
        as={Link}
        to="/support/live-chat"
        target="_blank"
      >
        {CONSTANTS.CHAT_NOW}
      </Button>
    </Box>
  );
}
